import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Loading } from '@js/components/common/Loading';
import { usePath } from '@js/hooks/usePath';
import { Context } from '@js/routes';

type Props = {
  children: React.ReactNode
  formId: string
  isEdit: boolean
  isBlocked?: boolean
};

const progressIndicator = ['基本情報', '担当者の情報', '実質的支配者', '投資適合性', '口座情報', '本人確認情報', '入力内容'];

export const InvestorRegistrationContainer = (props: Props) => {
  const { children, formId, isEdit, isBlocked = false } = props;
  const { isLoading, isSubmitting } = useContext(Context);
  const {
    stepLength,
    currentStep,
    nextStep,
    prevStep,
    isFirstStep,
    isConfirmStep
  } = usePath(isEdit);
  const stepName = `${currentStep.name}の${isConfirmStep ? '確認' : '入力'}`;
  const nextStepName = isConfirmStep ? null : `${nextStep.name}の${currentStep.id === stepLength - 2 ? '確認' : '入力'}`;
  return isLoading ?
    <Loading /> :
    <>
      {!isEdit && (
        <div className="bg--gray register-wrap">
          <nav className="step-nav step-nav--corporate">
            <ul className="step-nav__list">
              {progressIndicator.map((step, index) =>
                <li
                  className={`step-nav__item step-nav__item--corporate ${currentStep.stepNum === index && 'is-active'}`}
                  key={index}
                >
                  <span className="step-nav__number">{index + 1}</span>{step}<br className="is-sp" />の{index === progressIndicator.length - 1 ? '確認' : '入力'}
                </li>
              )}
            </ul>
          </nav>
        </div>
      )}
      <div className="layout-container pb64">
        <div className="panel">
          <div className="panel-contents--form">
            {/* 「本人確認情報」のときのみ文末に「(取引担当者)」をつける */}
            {currentStep.id !== 6 && <h2 className="title-page--flow mb0">{stepName}</h2>}
            {currentStep.id === 6 && <h2 className="title-page--flow mb0">本人確認情報の入力(取引担当者)</h2>}
            {currentStep.id === 2 && <span className="title-page__note">※実質的支配者が複数いる場合は全員分ご入力ください。</span>}
            <>
              {children}
              {isEdit ? (
                <div className="form-step-button pb16 form-page-button">
                  <button type="submit" className="form-step-button__action button-base--action" form={formId} disabled={isSubmitting || isBlocked}>
                    {isSubmitting ? '送信中...' : '送信'}
                    <span className="material-icons button-icon-right flip-horizontal">keyboard_backspace</span>
                  </button>
                </div>
              ) : (
                <div className="form-step-button pb16 form-page-button">
                  {!isFirstStep && <Link to={ prevStep.path } className="form-step-button__sub button-base--sub">前の入力へ戻る</Link>}
                  <button type="submit" className="form-step-button__action button-base--action" form={formId} disabled={isSubmitting || isBlocked}>
                    {isSubmitting ? '送信中...' : `${nextStepName}へ進む`}
                    <span className="material-icons button-icon-right flip-horizontal">keyboard_backspace</span>
                  </button>
                </div>
              )}
            </>
          </div>
        </div>
      </div>
    </>;
};
